import { BANK_ANALYSIS_CONFIG } from "./bankAnalysisConfig";
import type { BankBreakdownRow } from "./bankDeclineData";

const DAY_MS = 86_400_000;
function dateValue(value: string): number | null {
	if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
	const time = Date.parse(`${value}T00:00:00Z`);
	return Number.isFinite(time) && new Date(time).toISOString().slice(0, 10) === value ? time : null;
}

export function repeatPolicy(period: { from: string; to: string }) {
	const from = dateValue(period.from), to = dateValue(period.to);
	if (from === null || to === null || to < from) return null;
	const days = (to - from) / DAY_MS + 1;
	const { day, week, month } = BANK_ANALYSIS_CONFIG.repeatedEntities;
	if (days <= day.days) return { days, minCount: day.minCount, severity: day.severity };
	if (days > month.days) return { days, minCount: Math.ceil(month.minCount * days / month.days), severity: month.severity };
	const [start, end] = days <= week.days ? [day, week] : [week, month];
	const minCount = Math.ceil(start.minCount + (end.minCount - start.minCount) * (days - start.days) / (end.days - start.days));
	return { days, minCount, severity: end.severity };
}

export function analyzeRepeats(rows: BankBreakdownRow[], policy: ReturnType<typeof repeatPolicy>) {
	const unknown = rows.filter(row => row.unknown || !row.label.trim() || row.label.trim() === "—");
	const known = rows.filter(row => !unknown.includes(row));
	return {
		attention: policy ? known.filter(row => row.count >= policy.minCount) : [],
		belowThreshold: policy ? known.filter(row => row.count < policy.minCount) : known,
		unknown,
	};
}
